/* 公司（组织管理） */
const company = {
 'add':"/sys/compMng/company/add",//组织管理-添加组织
  "del":"/sys/compMng/company/delete",//删除组织
  "list":"/sys/compMng/company/find",//查询组织列表
  "modify":"/sys/compMng/company/modify",//编辑组织
  "find":"/sys/compMng/company/select",//查询单个
}
const monitor = {
	'logList':"/monitor/log/actionlog/list",//系统日志
}


export{
	company,
  monitor
}
